function setGradientBackgrounds(colorMap) {
    // Select all labels with class 'opt-label'
    let labels = document.querySelectorAll('.opt-label');

    labels.forEach(label => {
        let classNames = label.className.split(' ');

        // Filter out 'opt-label' and only keep color classes
        let colorClasses = classNames.filter(className => className !== 'opt-label');

        if (colorClasses.length > 1) { // only process labels with combined colors
            let gradientColors = colorClasses.map(color => colorMap[color] || '#FFFFFF'); // default to white if color not found

            let gradientPercentage = 100 / gradientColors.length;
            let gradientString = gradientColors.map((color, index) => `${color} ${gradientPercentage * index}%, ${color} ${(gradientPercentage * (index + 1))}%`).join(', ');

            label.style.background = `linear-gradient(90deg, ${gradientString})`;
        }
    });
  }
  // Fetch color map and run the function once the page has loaded
  window.onload = async function() {
    let colorMap = await fetchColorMap();
    setGradientBackgrounds(colorMap);
  };